<div class="lp-story" style="position: relative; width: 100%; height: 100%; overflow: hidden">
  @let _background = background();
  @if (_background) {
    <lp-placeable-media
      [media]="_background"
      style="display: block; position: absolute; inset: 0"
      (started)="isPlayingBackground.set(true)"
      (finished)="onFinishedBackground()"
    />
  }
  @let _character = character();
  @if (_character) {
    <lp-character
      [character]="_character"
      [emotion]="isTalking() && characterEmotion() === 'Neutral' ? 'Talking' : characterEmotion()"
      style="
        position: absolute;
        height: 80%;
        bottom: -5%;
        left: 0;
        cursor: pointer;
        transition: translate 0.25s ease-out;
        filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.5));
        transform-origin: bottom left;
      "
      (click)="onClick()"
      [@talk]="talkTrigger()"
    />
  }
  @let _text = line()?.text;
  @if (_text && _text.text.length > 0) {
    <app-style-sheet-sprite
      [sprite]="_stylesService.STORY_PANEL_MAIN()?.container"
      [text]="_stylesService.STORY_PANEL_MAIN()?.text"
      style="position: absolute; left: 20%; bottom: 4%; right: 20%; cursor: pointer; user-select: none"
      (click)="onClick()"
      @modal
      (@modal.done)="onModalDone()"
    >
      <lp-text
        [text]="_text.text"
        [noSfx]="!!_text.audio?.url"
        [animate]="doAnimateTyping()"
        (started)="onStartedTyping()"
        (finished)="onFinishedTyping()"
      />
      <div style="position: absolute; padding: inherit; inset: 0">
        <div
          class="arrow"
          style="height: 1.25em; width: 1.25em; position: relative; top: 100%; left: 100%; transform: translate(-50%, -50%) rotate(90deg)"
          [@typingDone]="isTalking()"
        >
          <app-style-sheet-sprite [sprite]="_stylesService.SPRITE_ICON_ARROW()?.container" />
        </div>
      </div>
      @if (_character) {
        <app-style-sheet-sprite
          [sprite]="_stylesService.STORY_PANEL_TITLE()?.container"
          [text]="_stylesService.STORY_PANEL_TITLE()?.text"
          style="position: absolute; top: -1em; left: 3em"
          (click)="onClick()"
        >
          <h3 style="margin-inline: 0.5em; margin-block: -0.5em">{{ _character.displayName }}</h3>
        </app-style-sheet-sprite>
      }
    </app-style-sheet-sprite>
  } @else if (lineIndex() >= 0 && isLineFinished() && !autoContinue()) {
    <app-hud-button style="position: absolute; bottom: 1rem; right: 1rem" (click)="onClick()" @modal (@modal.done)="onModalDone()">
      Ga verder
    </app-hud-button>
  }
</div>
